/*eslint-disable*/
import { formatUserStories } from "../../app/helpers/helper";
import { isLoggedin } from "../../app/helpers/helper";
import VerticalPlayerCollapseCloseIcon from "../../assets/icons/VerticalPlayerCollapseCloseIcon";
import DefaultProfileImage from "../../assets/img/Profile.png";
import { PAGE } from "../../app/constants";
import { useLoginModalContext } from "../../app/context/LoginModal";
import useIsMobile from "../../app/hooks/useIsMobile";
import Bottom from "../Layouts/Bottom";
import StoryRailCarousel from "../common/Carousel/StoryRailCarousel/StoryRailCarousel";
import EmptyScreen from "../common/EmptyScreen";
import Loader from "../common/Loader";
import DailyCheckinPopup from "../DailyCheckinPopup";
import DownArrow from "./Icons/DownArrow";
import UpArrow from "./Icons/UpArrow";
import VideoItem from "./VideoItem";
import { getVideosData } from "./helpers";
import useVerticalPlayer from "./hooks/useVerticalPlayer";
import axios from "axios";
import gluedin from "gluedin-shorts-js";
import React, {
  createRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

const feedModule = new gluedin.GluedInFeedModule();
const StoryModule = new gluedin.GluedInStoryModule();

type VerticalPlayerProps = {
  templateType?: string;
  templateTypes?: string[];
};

const VerticalPlayer = ({ templateType, templateTypes }: VerticalPlayerProps) => {
  const { videos, setVideos, currentVideoIndex, setCurrentVideoIndex } =
    useVerticalPlayer();
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [hasMorePages, setHasMorePages] = useState(true);
  const { setShowLoginModal } = useLoginModalContext();
  const verticalPlayerRef = useRef<HTMLDivElement>(null);
  const videoRefs = useRef<any>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [story, setStory]: any = useState(null);
  const [storyTotal, setStoryTotal] = useState(0);
  const [afterKey, setAfterKey] = useState(" ");
  const limit = 6;
  const storyContainerRef = useRef(null);
  const [dynamicWidth, setDynamicWidth] = useState("150px");
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const isMobile = useIsMobile();
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const guestToken = JSON.parse(localStorage.getItem("guestToken") || "{}");
  const hasUserData = Boolean(localStorage.getItem("userData"));
  const normalizedTemplateTypes = (
    Array.isArray(templateTypes) && templateTypes.length
      ? templateTypes
      : typeof templateType === "string" && templateType
      ? [templateType]
      : []
  )
    .map((item) => String(item || "").toUpperCase())
    .filter(
      (item, index, list) =>
        (item === "POST" || item === "VERTICAL_VIDEO") &&
        list.indexOf(item) === index
    );
  const normalizedTemplateType =
    normalizedTemplateTypes.length === 1 ? normalizedTemplateTypes[0] : "";
  const normalizedTemplateTypeKey = normalizedTemplateTypes.join("|");

  // ⬇️ NEW: Sentinel + programmatic scroll lock for smooth paging
  const loadMoreRef = useRef<HTMLDivElement | null>(null);
  const isAutoScrollingRef = useRef(false);
  const buttonNavLockRef = useRef(false);
  const buttonScrollTargetIndexRef = useRef<number | null>(null);
  const scrollSettleRafRef = useRef<number | null>(null);
  const scrollSettleTimeoutRef = useRef<number | null>(null);
  const scrollListenerCleanupRef = useRef<(() => void) | null>(null);
  const settleTargetTopRef = useRef<number | null>(null);
  const lastScrollEventTsRef = useRef(0);
  const [isFetchingNext, setIsFetchingNext] = useState(false); // NEW
  const [likedByMeMap, setLikedByMeMap] = useState<Record<string, boolean>>({});
  const [userMetaMap, setUserMetaMap] = useState<Record<string, any>>({});
  const likedByMeRef = useRef<Record<string, boolean>>({});
  const userMetaRef = useRef<Record<string, any>>({});
  const videosRef = useRef<any[]>([]);
  const pendingLikeIds = useRef<Set<string>>(new Set());
  const pendingMetaIds = useRef<Set<string>>(new Set());
  const consecutiveEmptyFilteredPagesRef = useRef(0);
  const seenPageSignaturesRef = useRef<Set<string>>(new Set());
  const MAX_EMPTY_FILTERED_PAGES = 12;

  useEffect(() => {
    likedByMeRef.current = likedByMeMap;
  }, [likedByMeMap]);

  useEffect(() => {
    userMetaRef.current = userMetaMap;
  }, [userMetaMap]);

  useEffect(() => {
    videosRef.current = videos;
  }, [videos]);

  useEffect(() => {
    const userLoginStatus = async () => {
      const isLogin = await isLoggedin();
      setIsUserLoggedIn(isLogin);
    };

    userLoginStatus();
  }, []);

  const [pagination, setPagination] = useState({
    afterKey: afterKey,
    limit: limit,
    offset: 1,
  });

  useEffect(() => {
    setVideos([]);
    setCurrentVideoIndex(0);
    setPage(1);
    setIsLoading(true);
    setHasMorePages(true);
    consecutiveEmptyFilteredPagesRef.current = 0;
    seenPageSignaturesRef.current.clear();
  }, [normalizedTemplateTypeKey, setCurrentVideoIndex, setVideos]);

  useEffect(() => {
    if (storyContainerRef.current) {
      const items = storyContainerRef.current as any;
      let totalWidth = 0;

      Array.from(items).forEach((item: any) => {
        totalWidth += item.offsetWidth;
      });

      setDynamicWidth(isOpen ? `${Math.max(totalWidth, 768)}px` : "150px");
    }
  }, [isOpen]);

  const calculateItemsToShow = () => {
    if (window.innerWidth <= 768) {
      return 5;
    } else if (window.innerWidth <= 1536) {
      return 5;
    } else {
      return 5;
    }
  };

  useEffect(() => {
    async function getStories() {
      try {
        const storyList = await StoryModule.getStory(pagination);
        if (storyList.status === 200) {
          const storyCollectionformat = await formatUserStories(
            storyList?.data?.result,
            pagination.offset
          );
          setStoryTotal(storyList?.data?.total);
          let storyObj = {
            storyCollection: [
              ...(story?.storyCollection || []),
              ...storyCollectionformat,
            ],
            pagination: pagination,
          };
          setStory(storyObj);
          setAfterKey(storyList?.data?.nextAfterKey?.userId);
        }
      } catch (error) {
        console.error(error);
      }
    }
    getStories();
  }, [pagination]);

  const handleNextStory = async () => {
    setPagination((prev: any) => ({
      ...prev,
      afterKey: afterKey,
      offset: prev.offset + 1,
    }));
  };

  const handleStoryNext = async () => {
    const itemsToShow = calculateItemsToShow();
    setCurrentIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;
      if (
        nextIndex >= story?.storyCollection.length - itemsToShow &&
        story?.storyCollection.length % limit === 0
      ) {
        handleNextStory();
      }
      return nextIndex;
    });
  };

  const handleStoryPrevious = () => {
    setCurrentIndex((prevIndex) => {
      const nextIndex = prevIndex - 1;
      if (nextIndex >= 0) {
        return nextIndex;
      }
      return prevIndex;
    });
  };

  const hasMapKey = (map: Record<string, any>, key: string) =>
    Object.prototype.hasOwnProperty.call(map, key);

  useEffect(() => {
    if (!hasMorePages && page !== 1) return;

    const fetchVideos = async () => {
      try {
        if (isFetchingNext) return; // NEW
        setIsFetchingNext(true); // NEW

        const limit = 6;
        const feedRequest: any = {
          limit: limit,
          offset: page,
          ...(normalizedTemplateType
            ? {
                // SDK feed filter key for layout split
                posType: normalizedTemplateType,
              }
            : {}),
        };

        // POST feed can include non-video primary media; restricting by c_type=video
        // can filter out valid POST cards and cause empty-loop pagination.
        const isMixedTemplateFeed = normalizedTemplateTypes.length > 1;
        if (!isMixedTemplateFeed && normalizedTemplateType !== "POST") {
          feedRequest.c_type = "video";
        }

        const feedResponse = await feedModule.getFeedList(feedRequest);
        const feeds = Array.isArray(feedResponse?.data?.result)
          ? feedResponse.data.result
          : [];
        const totalFeedCount = Number(feedResponse?.data?.total);
        const knownTotalPages =
          Number.isFinite(totalFeedCount) && totalFeedCount >= 0
            ? Math.ceil(totalFeedCount / limit)
            : null;

        const parsedVideos = getVideosData(feeds, videosRef.current.length) || [];
        const pageIds = feeds
          .map((item: any) => item?.videoId || item?.id || item?._id)
          .filter(Boolean);
        const pageSignature = `${pageIds.join(",")}|${feeds.length}`;
        const isDuplicatePage = seenPageSignaturesRef.current.has(pageSignature);
        if (!isDuplicatePage) {
          seenPageSignaturesRef.current.add(pageSignature);
        }
        const allowedTemplateTypes = new Set(normalizedTemplateTypes);
        const filteredVideos = allowedTemplateTypes.size
          ? parsedVideos.filter((item: any) => {
              const feedTemplateType = String(
                item?.templateType ||
                  item?.metakeys?.templateType ||
                  item?.template_type ||
                  item?.metakeys?.template_type ||
                  "VERTICAL_VIDEO"
              ).toUpperCase();
              return allowedTemplateTypes.has(feedTemplateType);
            })
          : parsedVideos;
        const hasNextPage =
          knownTotalPages !== null ? page < knownTotalPages : feeds.length === limit;
        const canContinuePaging = hasNextPage && !isDuplicatePage;

        if (!filteredVideos.length) {
          consecutiveEmptyFilteredPagesRef.current += 1;
          const shouldStopOnEmptyScan =
            consecutiveEmptyFilteredPagesRef.current >= MAX_EMPTY_FILTERED_PAGES;

          if (canContinuePaging && !shouldStopOnEmptyScan) {
            setPage((prev) => prev + 1);
          } else {
            setHasMorePages(false);
          }
          setIsLoading(false);
          return;
        }
        consecutiveEmptyFilteredPagesRef.current = 0;

        setHasMorePages(canContinuePaging);
        const newVideoIds = filteredVideos
          .map((item: any) => item?.videoId)
          .filter(Boolean);
        const newUserIds = filteredVideos
          .map((item: any) => item?.user?.userId ?? item?.userId)
          .filter(Boolean);

        const missingLikeIds = newVideoIds.filter(
          (id: string) => !hasMapKey(likedByMeRef.current, id)
        );
        if (missingLikeIds.length) {
          setLikedByMeMap((prev) => {
            const next = { ...prev };
            missingLikeIds.forEach((id: string) => {
              if (!hasMapKey(next, id)) {
                next[id] = false;
              }
            });
            return next;
          });
        }

        const missingMetaIds = newUserIds.filter(
          (id: string) => !hasMapKey(userMetaRef.current, id)
        );
        if (missingMetaIds.length) {
          setUserMetaMap((prev) => {
            const next = { ...prev };
            missingMetaIds.forEach((id: string) => {
              if (!hasMapKey(next, id)) {
                next[id] = null;
              }
            });
            return next;
          });
        }

        const likeIdsToFetch = hasUserData
          ? missingLikeIds.filter(
              (id: string) => !pendingLikeIds.current.has(id)
            )
          : [];
        const metaIdsToFetch = missingMetaIds.filter(
          (id: string) => !pendingMetaIds.current.has(id)
        );

        const fetchSupplemental = async () => {
          if (likeIdsToFetch.length) {
            likeIdsToFetch.forEach((id: string) =>
              pendingLikeIds.current.add(id)
            );
            try {
              const response = await feedModule.Like(likeIdsToFetch);
              const { status, data } = response ?? {};
              if (status === 200 || status === 201) {
                const likedIds = new Set(
                  Array.isArray(data?.result) ? data.result : []
                );
                setLikedByMeMap((prev) => {
                  const next = { ...prev };
                  likeIdsToFetch.forEach((id: string) => {
                    next[id] = likedIds.has(id);
                  });
                  return next;
                });
              }
            } catch (error) {
              console.error(error);
            } finally {
              likeIdsToFetch.forEach((id: string) =>
                pendingLikeIds.current.delete(id)
              );
            }
          }

          if (metaIdsToFetch.length) {
            metaIdsToFetch.forEach((id: string) =>
              pendingMetaIds.current.add(id)
            );
            try {
              const response = await feedModule.getMetadata({
                type: "storyOwner",
                ids: metaIdsToFetch,
              });
              if (response?.status === 200) {
                const items = response?.data?.result?.storyOwner || [];
                setUserMetaMap((prev) => {
                  const next = { ...prev };
                  items.forEach((item: any) => {
                    const id = item?.userId ?? item?.id;
                    if (id) {
                      next[id] = item;
                    }
                  });
                  return next;
                });
              }
            } catch (error) {
              console.error(error);
            } finally {
              metaIdsToFetch.forEach((id: string) =>
                pendingMetaIds.current.delete(id)
              );
            }
          }
        };

        if (likeIdsToFetch.length || metaIdsToFetch.length) {
          void fetchSupplemental();
        }

        const videosData = [...videosRef.current, ...filteredVideos];
        setVideos(videosData);

        videoRefs.current = [
          ...videosData.map(() => createRef<HTMLDivElement>()),
        ];
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      } finally {
        setIsFetchingNext(false); // NEW
      }
    };

    fetchVideos();
  }, [
    page,
    hasMorePages,
    normalizedTemplateTypeKey,
    setVideos,
  ]);

  const clearProgrammaticScrollWatchers = useCallback(() => {
    if (scrollSettleRafRef.current) {
      window.cancelAnimationFrame(scrollSettleRafRef.current);
      scrollSettleRafRef.current = null;
    }
    if (scrollSettleTimeoutRef.current) {
      window.clearTimeout(scrollSettleTimeoutRef.current);
      scrollSettleTimeoutRef.current = null;
    }
    if (scrollListenerCleanupRef.current) {
      scrollListenerCleanupRef.current();
      scrollListenerCleanupRef.current = null;
    }
  }, []);

  const finalizeProgrammaticScroll = useCallback(
    (finalIndex: number) => {
      const container = verticalPlayerRef.current;
      if (container) {
        const cards = container.getElementsByClassName(
          "player_item_wrapper"
        ) as HTMLCollectionOf<HTMLElement>;
        const targetCard = cards?.[finalIndex];
        if (targetCard) {
          const centeredTop = Math.max(
            0,
            targetCard.offsetTop -
              Math.max((container.clientHeight - targetCard.offsetHeight) / 2, 0)
          );
          container.scrollTo({ top: centeredTop, behavior: "auto" });
        }
      }

      clearProgrammaticScrollWatchers();
      setCurrentVideoIndex(finalIndex);
      buttonScrollTargetIndexRef.current = null;
      settleTargetTopRef.current = null;
      isAutoScrollingRef.current = false;
      buttonNavLockRef.current = false;
    },
    [clearProgrammaticScrollWatchers, setCurrentVideoIndex]
  );

  // Deterministic button paging: lock until scroll settles at one target index.
  const scrollToIndex = useCallback(
    (idx: number) => {
      const container = verticalPlayerRef.current;
      if (!container) {
        buttonNavLockRef.current = false;
        return;
      }

      const cards = container.getElementsByClassName(
        "player_item_wrapper"
      ) as HTMLCollectionOf<HTMLElement>;
      const targetCard = cards?.[idx];
      const targetTop = targetCard
        ? Math.max(
            0,
            targetCard.offsetTop -
              Math.max((container.clientHeight - targetCard.offsetHeight) / 2, 0)
          )
        : Math.max(0, idx * container.clientHeight);

      clearProgrammaticScrollWatchers();
      isAutoScrollingRef.current = true;
      buttonScrollTargetIndexRef.current = idx;
      settleTargetTopRef.current = targetTop;
      lastScrollEventTsRef.current = performance.now();

      const onScroll = () => {
        lastScrollEventTsRef.current = performance.now();
      };
      container.addEventListener("scroll", onScroll, { passive: true });
      scrollListenerCleanupRef.current = () => {
        container.removeEventListener("scroll", onScroll);
      };

      const checkSettled = () => {
        const now = performance.now();
        const idleForMs = now - lastScrollEventTsRef.current;
        const target = settleTargetTopRef.current;
        const distanceToTarget =
          target === null ? Number.POSITIVE_INFINITY : Math.abs(container.scrollTop - target);
        if (idleForMs > 120 && distanceToTarget <= 2) {
          finalizeProgrammaticScroll(idx);
          return;
        }
        scrollSettleRafRef.current = window.requestAnimationFrame(checkSettled);
      };
      scrollSettleRafRef.current = window.requestAnimationFrame(checkSettled);

      scrollSettleTimeoutRef.current = window.setTimeout(() => {
        finalizeProgrammaticScroll(idx);
      }, 1200);

      container.scrollTo({ top: targetTop, behavior: "smooth" });
    },
    [clearProgrammaticScrollWatchers, finalizeProgrammaticScroll]
  );

  useEffect(() => {
    return () => {
      clearProgrammaticScrollWatchers();
    };
  }, [clearProgrammaticScrollWatchers]);

  // ⬇️ REMOVED the old scrollIntoView + scroll listener effect
  // (No code block here—just noting removal.)

  // ⬇️ NEW: Bottom sentinel for pagination (replaces scroll handler)
  useEffect(() => {
    const el = loadMoreRef.current;
    const root = verticalPlayerRef.current;
    if (!el || !root) return;

    let ticking = false;
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (
          entry.isIntersecting &&
          !isAutoScrollingRef.current &&
          !ticking &&
          !isFetchingNext && // NEW: don’t double-trigger while loading
          hasMorePages
        ) {
          ticking = true;
          setPage((prev) => prev + 1);
          setTimeout(() => (ticking = false), 300);
        }
      },
      {
        root,
        threshold: 0, // NEW
        rootMargin: "200px 0px 200px 0px", // NEW: fire before exact bottom
      }
    );

    observer.observe(el);
    return () => observer.disconnect();
    // Recreate observer when list length changes (sentinel moves down)
  }, [hasMorePages, videos.length, isFetchingNext]);

  useEffect(() => {
    if (
      videos.length &&
      currentVideoIndex >= videos.length - 3 &&
      !isFetchingNext &&
      hasMorePages
    ) {
      setPage((p) => p + 1);
    }
  }, [currentVideoIndex, hasMorePages, videos.length, isFetchingNext]);

  // ⬇️ REMOVED: duplicate early-load trigger on index == length-2
  // useEffect(() => {
  //   if (currentVideoIndex === videos.length - 2) {
  //     setPage((prev) => prev + 1);
  //   }
  // }, [currentVideoIndex, videos.length]);

  const lockButtonNavigation = () => {
    if (buttonNavLockRef.current) return false;
    buttonNavLockRef.current = true;
    return true;
  };

  const releaseButtonNavigationLock = () => {
    buttonNavLockRef.current = false;
  };

  const getActiveIndexFromScroll = useCallback(() => {
    const container = verticalPlayerRef.current;
    if (!container) return currentVideoIndex;
    const cards = container.getElementsByClassName(
      "player_item_wrapper"
    ) as HTMLCollectionOf<HTMLElement>;
    if (!cards?.length) return currentVideoIndex;

    const viewportCenter = container.scrollTop + container.clientHeight / 2;
    let nearestIndex = currentVideoIndex;
    let nearestDelta = Number.POSITIVE_INFINITY;

    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      const cardCenter = card.offsetTop + card.offsetHeight / 2;
      const delta = Math.abs(cardCenter - viewportCenter);
      if (delta < nearestDelta) {
        nearestDelta = delta;
        nearestIndex = i;
      }
    }

    return nearestIndex;
  }, [currentVideoIndex]);

  const handleNext = () => {
    if (!lockButtonNavigation()) return;
    const activeIndex = getActiveIndexFromScroll();
    const next = Math.min(activeIndex + 1, videos.length - 1);
    if (next === activeIndex) {
      releaseButtonNavigationLock();
      return;
    }
    scrollToIndex(next);
  };

  const handlePrev = () => {
    if (!lockButtonNavigation()) return;
    const activeIndex = getActiveIndexFromScroll();
    const prev = Math.max(activeIndex - 1, 0);
    if (prev === activeIndex) {
      releaseButtonNavigationLock();
      return;
    }
    scrollToIndex(prev);
  };

  // ⬇️ UPDATED: single keydown listener (passive) using same handlers
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.key === "ArrowDown" &&
        currentVideoIndex !== videos.length - 1
      ) {
        handleNext();
      } else if (event.key === "ArrowUp" && currentVideoIndex !== 0) {
        handlePrev();
      }
    };

    window.addEventListener("keydown", handleKeyDown, { passive: true });
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [currentVideoIndex, videos.length]);

  const loginModalHandler = () => {
    setShowLoginModal(true);
  };

  return (
    <>
      <DailyCheckinPopup />
      {isLoading && <Loader />}
      {!isLoading && videos.length === 0 && (
        <div className="main-wrapper">
          <div className="row-responsive"><div className="mid-content">
              <div className="player_wrapper">
                <EmptyScreen
                  title="No content available for this view."
                  fullHeight={true}
                />
              </div>
            </div>
            <Bottom />
          </div>
        </div>
      )}
      {!isLoading && videos.length > 0 && (
        <div className="main-wrapper">
          <div className="row-responsive"><div className="mid-content">
              {currentVideoIndex !== videos.length - 1 && (
                <button onClick={handleNext} className="next-btn">
                  <DownArrow />
                </button>
              )}
              {currentVideoIndex > 0 && (
                <button onClick={handlePrev} className="prev-btn">
                  <UpArrow />
                </button>
              )}
              <div
                ref={verticalPlayerRef}
                id="vertical-player"
                className="player_wrapper"
              >
                {story?.storyCollection?.length > 0 && isUserLoggedIn && (
                  <div
                    className="story-container"
                    ref={storyContainerRef}
                    onClick={(e) => {
                      setIsOpen(true);
                      e.stopPropagation();
                    }}
                    style={{
                      width: isOpen
                        ? isMobile
                          ? "100%"
                          : "fit-content"
                        : "150px",
                      top: isOpen ? "20px" : "45px",
                      maxWidth: "640px",
                    }}
                  >
                    {isOpen ? (
                      <div className="expanding-container">
                        {isOpen && (
                          <StoryRailCarousel
                            carouselItems={story?.storyCollection}
                            autoplay={false}
                            loop={false}
                            onNext={handleStoryNext}
                            onPrevious={handleStoryPrevious}
                            storyType={PAGE.FEED}
                            pagination={story?.pagination}
                          />
                        )}
                      </div>
                    ) : (
                      <div className="expanding-toggle">
                        <img
                          src={
                            story?.storyCollection[0]?.profileImageUrl
                              ? story?.storyCollection[0]?.profileImageUrl
                              : DefaultProfileImage
                          }
                          alt=""
                          width={35}
                          height={35}
                          className="expanding-toggle-img1"
                        />
                        {storyTotal > 1 && (
                          <img
                            src={
                              story?.storyCollection[1]?.profileImageUrl
                                ? story?.storyCollection[1]?.profileImageUrl
                                : DefaultProfileImage
                            }
                            alt=""
                            width={35}
                            height={35}
                            className="expanding-toggle-img2"
                          />
                        )}

                        <span>
                          {storyTotal === 1
                            ? "Story"
                            : `${storyTotal - 1}+ Stories`}
                        </span>
                      </div>
                    )}
                    {isOpen && (
                      <button
                        onClick={(e) => {
                          setIsOpen(!isOpen);
                          e.stopPropagation();
                        }}
                        className="absolute left-[50%] translate-x-[-50%] bottom-[-40px]"
                      >
                        <VerticalPlayerCollapseCloseIcon className="w-[32px] h-[32px]" />
                      </button>
                    )}
                  </div>
                )}
                {videos?.map((video: any, index: number) => (
                  <VideoItem
                    ref={videoRefs.current[index]}
                    video={video}
                    key={video.id}
                    setVideos={setVideos}
                    setCurrentVideoIndex={setCurrentVideoIndex}
                    suppressIndexSyncRef={isAutoScrollingRef}
                    allVideoRefs={videoRefs}
                    likedByMe={likedByMeMap[video?.videoId]}
                    userMeta={
                      userMetaMap[video?.user?.userId ?? video?.userId]
                    }
                  />
                ))}
                {hasMorePages && (
                  <div ref={loadMoreRef} style={{ height: 200 }} />
                )}
              </div>
            </div>
            <Bottom />
          </div>
        </div>
      )}
    </>
  );
};

export default VerticalPlayer;
